import React, { useEffect, useRef } from 'react';

const COMMON_EMOJIS = ['👍', '❤️', '😂', '🎉', '🚀', '👀', '🔥', '✅'];

const ReactionPicker = ({ onSelect, onClose }) => {
  const pickerRef = useRef(null);

  // Close picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div
      ref={pickerRef}
      className="absolute bottom-full left-0 mb-2 bg-white border border-secondary-200 rounded-lg shadow-lg p-2 z-10"
    >
      <div className="flex space-x-1">
        {COMMON_EMOJIS.map((emoji) => (
          <button
            key={emoji}
            onClick={() => onSelect(emoji)}
            className="p-2 hover:bg-secondary-100 rounded text-xl transition-colors"
            title={`React with ${emoji}`}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ReactionPicker;
